/* hey-search-typer — søgefeltets placeholder skriver og sletter
   eksempelord (Watery-mønster): Søg efter "Hundekurv" → sletter →
   "Barbermaskine" → ... Ordene kommer fra data-hey-words på input'et.
   Stopper, så snart kunden fokuserer feltet eller skriver i det. */
(function () {
  'use strict';
  var tries = 0;
  function init() {
    var input = document.querySelector('#search input[type="search"][data-hey-words]');
    // defer-scripts kører FØR DOMContentLoaded — data-attributterne sættes
    // først dér, så vi prøver igen et par gange
    if (!input) { if (tries++ < 20) { setTimeout(init, 150); } return; }
    if (input.getAttribute('data-hey-typing')) { return; }
    input.setAttribute('data-hey-typing', '1');
    var words = (input.getAttribute('data-hey-words') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 1) { return; }
    // editoren trimmer mellemrum i slutningen af tekstfelter — sæt det på igen
    var prefix = (input.getAttribute('data-hey-prefix') || 'Søg efter').replace(/\s+$/, '') + ' ';
    var quote = input.getAttribute('data-hey-quote') !== 'false';
    // Hvor laenge det faerdige ord staar stille, foer det slettes igen.
    // 1600 ms var for kort til at naa at laese det — Matias bad om et par
    // sekunder. Saettes i Tema-indstillinger under Soegefelt (Hey).
    var hold = parseInt(input.getAttribute('data-hey-hold'), 10);
    if (!(hold > 0)) { hold = 2600; }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { input.placeholder = prefix + (quote ? '"' + words[0] + '"' : words[0]); return; }

    var wi = 0, ci = 0, deleting = false, timer = null, stopped = false;
    function render(txt) { input.placeholder = prefix + (quote ? '"' + txt + '"' : txt); }
    function tick() {
      if (stopped) { return; }
      var word = words[wi];
      if (!deleting) {
        ci++;
        render(word.slice(0, ci));
        if (ci >= word.length) { deleting = true; timer = setTimeout(tick, hold); return; }
        timer = setTimeout(tick, 70 + Math.random() * 60);
      } else {
        ci--;
        render(word.slice(0, ci));
        if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; timer = setTimeout(tick, 350); return; }
        timer = setTimeout(tick, 35);
      }
    }
    function stop() {
      stopped = true; clearTimeout(timer);
      input.placeholder = input.getAttribute('data-hey-static') || prefix.trim().replace(/\s+$/, '') + '…';
    }
    input.addEventListener('focus', stop, { once: true });
    input.addEventListener('input', stop, { once: true });
    // pausér når fanen ikke er synlig — ellers hober timeouts sig op
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(timer); } else if (!stopped) { timer = setTimeout(tick, 400); }
    });
    timer = setTimeout(tick, 600);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
